// 
export const IMPORT_BOOKING_LIST = 'IMPORT_BOOKING_LIST';
export const IMPORT_BOOKING_CANCEL_LIST = 'IMPORT_BOOKING_CANCEL_LIST';
export const IMPORT_BOOKING_CANCEL_PAGINATION = 'IMPORT_BOOKING_CANCEL_PAGINATION';
export const IMPORT_BOOKING_PAGINATION = 'IMPORT_BOOKING_PAGINATION';
export const IMPORT_BOOKING_SUMMARY = 'IMPORT_BOOKING_SUMMARY';
export const IMPORT_BOOKING_CANCEL_SUMMARY = 'IMPORT_BOOKING_CANCEL_SUMMARY';
